import React from "react";
import styled from "styled-components";

import SearchIcon from "../../lib/images/search.svg";

export interface PageHeaderProps {
  areAllGroupsExpanded: boolean;
  areAnyFiltersApplied: boolean;
  onClearFilters: () => void;
  expandAllGroups: () => void;
  refreshData: () => void;
  exportData: () => void;
  isExportEnabled: boolean;
  searchTextDidChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  shouldShowExpandAllButton: boolean;
  shouldShowRefreshButton: boolean;
}

const HeaderContainer = styled.div`
  max-width: 1345px;
  margin: 30px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SearchField = styled.input`
  background-color: white;
  border-radius: 4px;
  border: 1px solid rgba(14, 63, 98, 0.5);
  width: 450px;
  border-radius: 4px;
  background-image: url(${ SearchIcon });
  background-position: center left 15px;
  background-repeat: no-repeat;
  padding: 8px 11px 8px 45px;
  
  font-family: 'Lexend';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #0E3F62;
  
  &::placeholder {
    color: rgba(14, 63, 98, 0.5);
  }
  
  &:focus {
    outline: none;
    border: 1px solid #1468A5;
  }
`;

export const StyledButton = styled.button`
  text-transform: uppercase;
  background-color: #1468A5;
  color: white;
  font-family: 'Lexend';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  padding: 9px 18px;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  
  &[disabled] {
    cursor: default;
    background-color: #84838D;
    color: rgba(255, 255, 255, 0.6);
  }
  
  &:active {
    background-color: #105588;
  }
`;

const ExpandAllButton = styled(StyledButton)`
  margin: 0 2em;
  
  &::before {
    content: '▶︎';
    display: inline-block;
    margin-right: 0.5em;
    transition: rotate 0.2s ease;
  }
  
  &.expanded::before {
    rotate: 0.25turn;
  }
`;

const TrailingButtonLayoutContainer = styled.div`
  display: flex;
  gap: 20px;
`;

const PageHeader = (props: PageHeaderProps) => {
  
  const { 
    shouldShowExpandAllButton,
    shouldShowRefreshButton,
    searchTextDidChange, 
    expandAllGroups, 
    refreshData, 
    exportData,
    areAllGroupsExpanded,
    isExportEnabled,
    onClearFilters, 
    areAnyFiltersApplied } = props;

  return (
    <HeaderContainer>
      <div>
        <SearchField
          onChange={searchTextDidChange}
          placeholder="Search for deals"
          type="search"
        />

        { shouldShowExpandAllButton && 
          <ExpandAllButton
            onClick={expandAllGroups}
            className={areAllGroupsExpanded ? "expanded" : undefined}>
              { areAllGroupsExpanded ? "Collapse All" : "Expand All" }
          </ExpandAllButton> }
          
        { areAnyFiltersApplied && 
          <StyledButton onClick={onClearFilters}>Clear Filters</StyledButton>
        }
      </div>
      
      <TrailingButtonLayoutContainer>
        { shouldShowRefreshButton && <StyledButton onClick={refreshData}>Refresh Deals</StyledButton> }
        <StyledButton disabled={!isExportEnabled} onClick={exportData}>Export</StyledButton>
      </TrailingButtonLayoutContainer>
    </HeaderContainer>
  );
};

export default PageHeader;
